import React from "react";

/*
`hideIndicator` hides the radio circle so the card highlight alone shows the
selection. The input stays in the DOM for keyboard and screen-reader access.
*/
export default function RadioGroup({
  name,
  options,
  value,
  onChange,
  hideIndicator = false,
  className,
}) {
  const classes = [
    "rma-nc-radio-group",
    hideIndicator ? "rma-nc-radio-group--no-indicator" : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      {options.map(function (option) {
        const isSelected = option.value === value;
        const optionClasses = [
          "rma-nc-radio-option",
          isSelected ? "rma-nc-radio-option--selected" : null,
        ]
          .filter(Boolean)
          .join(" ");

        return (
          <label key={option.value} className={optionClasses}>
            <input
              type="radio"
              name={name}
              checked={isSelected}
              onChange={function () {
                onChange(option.value);
              }}
            />
            <span>{option.label}</span>
          </label>
        );
      })}
    </div>
  );
}
